import { useState, useEffect} from "react";
import Axios from "middleware/axiosInstance";
import "antd/dist/antd.css";
import {Row, Col, Form, Input, Select } from "antd";
import Icon from "react-multi-date-picker/components/icon";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ButtonComponent from "components/Form/ButtonComponent";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { useNavigate } from "react-router-dom";
import { convertToMiladi } from "utils/dateCoverter";

const { Option } = Select;
const { TextArea } = Input;
const CreatePerson = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const [newPerson, setNewPerson] = useState({});
  const [peopleGroup, setPeopleGroup] = useState();
  const [allProvinceAndCities, setAllProvinceAndCities] = useState();
  const [citiesOfSelectedProvince, setCitiesOfSelectedProvince] =
    useState(null);
  const [birthdate, setBirthdate] = useState(null);

  const CreatePersonHandler = () => {
    Axios.post("/people", newPerson)
      .then((res) => {
        OpenNotificationWithIcon("ثبت موفق", "شخص جدید با موفقیت ایجاد شد!");
        navigate("/warehouse/persons")
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const getPeopleGroup = () => {
    Axios.get("/g_people")
      .then((res) => {
        setPeopleGroup(res.data);
      })
      .catch((err) => {
        setPeopleGroup(false);
        alert("گروه اشخاص دریافت نشد");
        console.log(err);
      });
  };

  const getAndSetAllprovince = () => {
    Axios.get("/province")
      .then((res) => {
        console.log(res.data);
        setAllProvinceAndCities(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAndSetAllCitiesOfSelectedProvince = () => {
    Axios.get(`/province?id=${newPerson.province_id}`)
      .then((res) => {
        console.log(res.data);
        setCitiesOfSelectedProvince(res.data[0].city);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // getAllPersons()
    getPeopleGroup();
    getAndSetAllprovince();
  }, []);

  useEffect(() => {
    getAndSetAllCitiesOfSelectedProvince();
    console.log("taghir kard");
  }, [newPerson.province_id]);

  const handleFormValuesChange = (changedValues) => {
    console.log(changedValues);

    const formFieldName = Object.keys(changedValues)[0];
    setNewPerson({
      ...newPerson,
      [formFieldName]: changedValues[formFieldName],
    });
  };

  const changeDateAndTimeOfDocHandler = (e) => {
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    const dateInMiladi = convertToMiladi(dateInShamsi)
    setBirthdate({ shamsi: dateInShamsi, miladi: dateInMiladi });
    setNewPerson({
      ...newPerson,
      dob: dateInMiladi,
    });
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onValuesChange={handleFormValuesChange}
        >
          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="people_id"
                label=" گروه"
                rules={[
                  {
                    required: true,
                    message: "لطفا گروه را نتخاب فرمایید",
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  showSearch
                // defaultValue="..."
                >
                  {peopleGroup?.map((peopleGroup) => {
                    return (
                      <Option key={peopleGroup.id} value={peopleGroup.id}>
                        {peopleGroup.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="نام"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "لطفا نام را وارد فرمایید",
                  },
                  { min: 2 },
                  { max: 40 },
                ]}
                hasFeedback
              >
                <Input placeholder="نام " />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label=" نام خانوادگی"
                name="family"
                rules={[
                  {
                    required: true,
                    message: "لطفا  نام خانوادگی را وارد فرمایید",
                  },
                  { min: 2 },
                  { max: 50 },
                ]}
                hasFeedback
              >
                <Input placeholder=" نام خانوادگی " />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="dob" label="تاریخ تولد">
                <Input
                  disabled
                  placeholder={
                    birthdate ? `${birthdate.shamsi}` : "انتخاب تاریخ"
                  }
                  addonBefore={
                    <DatePicker
                      // value={newWarehouseEntryDocument.date}
                      onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-left"
                      // format="HH:MM"
                      // plugins={[<TimePicker hideSeconds />]}
                      render={
                        <Icon
                          style={{
                            color: "gray",
                            width: "23px",
                          }}
                        />
                      }
                    />
                  }
                />
              </Form.Item>
            </Col>
            {/* </Row>

          <Row> */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="phone" label="تلفن ثابت">
                <Input
                  rules={[{ min: 11 }, { max: 11 }]}
                  placeholder="02136589471"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="cellular_phone"
                label="تلفن همراه"
                rules={[{ min: 11 }, { max: 11 }]}
                hasFeedback
              >
                <Input placeholder="09122222222" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="type_person"
                label="نوع شخص"
                rules={[
                  {
                    required: true,
                    message: "لطفا نام را وارد فرمایید",
                  },
                ]}
              >
                <Select placeholder="انتخاب فرمایید" id="type_person">
                  <Select.Option value="genuine">حقیقی</Select.Option>
                  <Select.Option value="legal">حقوقی</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              {newPerson.type_person === "genuine" ? (
                <Form.Item
                  name="national_code"
                  label="کدملی"
                  rules={[{ min: 10 }, { max: 10 }]}
                  hasFeedback
                >
                  <Input placeholder="037111111" />
                </Form.Item>
              ) : (
                <Form.Item
                  name="shenaseh_melli"
                  label="شناسه ملی"
                  rules={[{ min: 11 }, { max: 11 }]}
                  hasFeedback
                >
                  <Input placeholder="037111111" />
                </Form.Item>
              )}
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="moravedat"
                label="مراودات"
                rules={[
                  {
                    required: true,
                    message: "لطفا نوع مراودات را انتخاب فرمایید",
                  },
                ]}
              >
                <Select placeholder="انتخاب فرمایید">
                  <Select.Option value="moshtari">مشتری</Select.Option>
                  <Select.Option value="tamin_konande">
                    تامین کننده
                  </Select.Option>
                  <Select.Option value="karkonan">کارکنان</Select.Option>
                  <Select.Option value="vaseteh">واسطه</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {/* </Row>

          <Row> */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item label=" نام شرکت" name="company_name" hasFeedback>
                <Input placeholder=" نام شرکت" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="code"
                label="کد"
                rules={[{ min: 5 }]}
                hasFeedback
              >
                <Input placeholder="123" />
              </Form.Item>
            </Col>
            {newPerson.type_person === "legal" ? (
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="economic_code"
                  label="کد اقتصادی"
                  rules={[{ min: 5 }]}
                  hasFeedback
                >
                  <Input placeholder="852555" />
                </Form.Item>
              </Col>
            ) : null}
            {/* </Row>

          <Row> */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="province_id" label="استان">
                <Select
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  showSearch
                  placeholder="استان"
                // defaultValue="استان"
                >
                  {allProvinceAndCities?.map((allProvinceAndCities) => {
                    return (
                      <Option
                        key={allProvinceAndCities.id}
                        value={allProvinceAndCities.id}
                      >
                        {allProvinceAndCities.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="city_id" label="شهر">
                <Select
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  showSearch
                  placeholder="ابتدا استان را انتخاب فرمایید"
                >
                  {citiesOfSelectedProvince?.map((citiesOfSelectedProvince) => {
                    return (
                      <Option
                        key={citiesOfSelectedProvince.id}
                        value={citiesOfSelectedProvince.id}
                      >
                        {citiesOfSelectedProvince.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="postal_code"
                label="کد پستی"
                rules={[{ min: 10 }, { max: 10 }]}
                hasFeedback
              >
                <Input placeholder="1234567890" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                name="email"
                label="ایمیل"
                rules={[{ type: "email", message: "ایمیل صحیح را وارد فرمایید" }]}
                hasFeedback
              >
                <Input placeholder="test@gmail.com" />
              </Form.Item>
            </Col>
          </Row>

          <Col xs={12} sm={16} md={24} lg={24}>
            <Form.Item label="آدرس" name="address">
              <TextArea rows={2} />
            </Form.Item>
          </Col>
          <Row>
            {/* <Button
              style={{ width: "50%", margin: "auto" }}
              type="primary"
              htmlType="submit"
              onClick={() => CreatePersonHandler()}
            >
              ثبت
            </Button> */}
            <ButtonComponent
              onClick={() => CreatePersonHandler()}
              value="ثبت"
            />
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default CreatePerson;
